'use strict';

/* jshint -W098 */
angular.module('mean.accounts-receivable').controller('AddEstimateController', ['$scope', '$rootScope', '$location', 'Global', 'MeanUser', 'toaster', '$filter', 'taskListService', 'ngDialog', 'tradeCodeService', 'tradeDrawService',
  function($scope, $rootScope, $location, Global, MeanUser, toaster, $filter, taskListService, ngDialog, tradeCodeService, tradeDrawService) {
    var vm = this;

    vm.user = MeanUser.user;
    vm.trade_code = tradeCodeService.getCode(vm.user.trade[0]);
  
    vm.state = $location.state();

    vm.back = function() {
        $location.url('/trades/accounts/receivable');
    };
  }
]);


// WEBPACK FOOTER //
// ./packages/custom/accounts-receivable/public/controllers/addEstimate.js